import { useHistory } from "react-router-dom";
import dino from "../../../assets/dinologoright.png";
import { StyledTitle } from "./styles";
import { GiReturnArrow } from "react-icons/gi";
import { useColorChanger } from "../../../hooks/useColorChanger";

interface LogoProps {
	title?: boolean;
	onClick?: () => void;
	isPageOnTop?: boolean;
}

export default function Logo({ title, onClick, isPageOnTop }: LogoProps) {
	const history = useHistory();
	const spotColor = useColorChanger(7);

	const valentin = "Valentin".split("");

	return (
		<>
			<StyledTitle
				spotColor={spotColor}
				hidden={!isPageOnTop}
				onClick={() => history.push("/")}
				isHome={history.location.pathname === "/"}
			>
				{title ? (
					<>
						Voltar a Home <img src={dino} alt="dino"></img>
					</>
				) : (
					<>
						<div className="img_btn_holder">
							<img src={dino} alt="dino"></img>{" "}
							<button>
								<GiReturnArrow />
							</button>
						</div>
						<div>
							{valentin.map((letter, i) => (
								<p key={i}>{letter}</p>
							))}
						</div>
					</>
				)}
			</StyledTitle>
		</>
	);
}
